// Students
export const FETCH_STUDENTS = 'FETCH_STUDENTS'
export const NEW_STUDENT = 'NEW_STUDENT'
export const DELETE_STUDENT = 'DELETE_STUDENT'
export const UPDATE_STUDENT = 'UPDATE_STUDENT'

// Staff
export const FETCH_STAFF = 'FETCH_STAFF'
export const NEW_STAFF = 'NEW_STAFF'
export const DELETE_STAFF = 'DELETE_STAFF'
export const UPDATE_STAFF = 'UPDATE_STAFF'

// Clusters
export const FETCH_CLUSTERS = 'FETCH_CLUSTERS'
export const NEW_CLUSTER = 'NEW_CLUSTER'
export const DELETE_CLUSTER = 'DELETE_CLUSTER'
export const UPDATE_CLUSTER = 'UPDATE_CLUSTER'
export const ATTACH_STUDENTS = 'ATTACH_STUDENTS'
export const DETATCH_STUDENTS = 'DETATCH_STUDENTS'

// Authorization
export const SET_CURRENT_USER = 'SET_CURRENT_USER'

// Starred
export const FETCH_STARRED = 'FETCH_STARRED'
export const STAR_ITEM = 'STAR_ITEM'
export const UNSTAR_ITEM = 'UNSTAR_ITEM'

// Student Profile
export const FETCH_STUDENT_PROFILE = 'FETCH_STUDENT_PROFILE'

// Student Schedule
export const FETCH_STUDENT_SCHEDULE = 'FETCH_STUDENT_SCHEDULE'

// Staff Schedule
export const FETCH_STAFF_SCHEDULE = 'FETCH_STAFF_SCHEDULE'

// Staff Profile
export const FETCH_STAFF_PROFILE = 'FETCH_STAFF_PROFILE'

// Settings
export const FETCH_SETTINGS = 'FETCH_SETTINGS'

// Notifications
export const ARCHIVE_ALL_NOTIFICATIONS = 'ARCHIVE_ALL_NOTIFICATIONS'
export const ARCHIVE_NOTIFICATION = 'ARCHIVE_NOTIFICATION'
export const FETCH_NOTIFICATION_INBOX = 'FETCH_NOTIFICATION_INBOX'
export const FETCH_NOTIFICATION_OUTBOX = 'FETCH_NOTIFICATION_OUTBOX'
export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ'
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ'
export const MARK_NOTIFICATION_UNREAD = 'MARK_NOTIFICATION_UNREAD'
export const UNARCHIVE_NOTIFICATION = 'UNARCHIVE_NOTIFICATION'
export const SEND_NOTIFICATION = 'SEND_NOTIFICATION'

// Check-in
export const FETCH_CHECKIN_STATUS = 'FETCH_CHECKIN_STATUS'
export const ENABLE_AIR = 'ENABLE_AIR'
export const DISABLE_AIR = 'DISABLE_AIR'
export const CHECK_IN = 'CHECK_IN'

// Topics
export const FETCH_TOPICS = 'FETCH_TOPICS'
export const NEW_TOPIC = 'NEW_TOPIC'
export const NEW_TOPIC_SCHEDULE = 'NEW_TOPIC_SCHEDULE'
export const DELETE_TOPIC = 'DELETE_TOPIC'
export const DELETE_TOPIC_SCHEDULE = 'DELETE_TOPIC_SCHEDULE'

// Snackbar
export const QUEUE_SNACKBAR = 'QUEUE_SNACKBAR'
export const DEQUEUE_SNACKBAR = 'DEQUEUE_SNACKBAR'

// Student Plan
export const FETCH_STAFF_LIST = 'FETCH_STAFF_LIST'

// Users
export const FETCH_USERS = 'FETCH_USERS'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const INVALIDATE_PASSWORD = 'INVALIDATE_PASSWORD'
export const DISABLE_USER = 'DISABLE_USER'

// Wiki
export const FETCH_WIKI_GROUPS = 'FETCH_WIKI_GROUPS'
export const FETCH_WIKI_GROUP_POSTS = 'FETCH_WIKI_GROUP_POSTS'
export const FETCH_WIKI_POST = 'FETCH_WIKI_POST'
export const CREATE_WIKI_POST = 'CREATE_WIKI_POST'
export const CREATE_WIKI_GROUP = 'CREATE_WIKI_GROUP'
export const UPDATE_WIKI_POST = 'UPDATE_WIKI_GROUP'
export const UPDATE_WIKI_GROUP = 'UPDATE_WIKI_GROUP'
